<template>
  <div id="billboard-window" class="lity-hide">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <h2>
            <i class="fas fa-map-marker-alt"></i>
            {{ titulo }}
            <span v-if="type_id == 2 && group_type == 'transport-station' && subtitle">: {{ subtitle }}</span>
          </h2>
        </div>
        <div class="col-12 pic cont-img">
          <div class="block-img"></div>
          <vue-load-image v-if="image" class="vue-load-image-details" v-show="image != null">
            <img slot="image" class="img-etiquet" :src="'/image/' + image" />
            <vue-loading slot="preloader" class="preloader-img" type="spin" color="#d9544e"
              :size="{ width: '50px', height: '50px' }"></vue-loading>

            <div slot="error" class="error-msg-img-detaills">
              <p>
                Ha ocurrido un error cargando la imagen. Revisa tu conexión de
                internet si el problema persiste.
              </p>
            </div>
          </vue-load-image>

          <a v-show="!inTheList" href="#" class="material-btn bt_red" role="button" @click="addList()">
            {{ $t("acciones.agregar") }}
            <i v-if="!part_circuit" class="fas fa-cart-plus"></i>
            <span v-if="part_circuit && screens_circuit > 0" class="circuit-number">+ {{ screens_circuit }}</span>
          </a>
          <a v-show="inTheList" href="#" class="material-btn bt_grey" role="button" @click="removeList()">
            {{ $t("acciones.remover") }}
            <i v-show="inTheList" class="far fa-trash-alt"></i>
          </a>
        </div>
        <div v-if="type_id != 2 && group_type != 'transport-station' && subtitle" class="circuit-descrip">
          <h4>{{ subtitle }}</h4>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6">
          <table class="table">
            <tbody>
              <tr>
                <td>
                  <h3>ID:</h3>
                </td>
                <td>
                  <p>0{{ id }}</p>
                </td>
              </tr>
              <tr>
                <td>
                  <h3>{{ $t("descripciones.ciudad") }}:</h3>
                </td>
                <td>
                  <p>{{ ciudad }}</p>
                </td>
              </tr>
              <tr>
                <td>
                  <h3>{{ $t("descripciones.tamano") }}:</h3>
                </td>
                <td>
                  <p>{{ screen_size }}</p>
                </td>
              </tr>
              <tr>
                <td>
                  <h3>{{ $t("descripciones.pixels") }}:</h3>
                </td>
                <td>
                  <p>{{ pixels }}</p>
                </td>
              </tr>
              <tr>
                <td>
                  <h3>{{ $t("descripciones.duracion") }}:</h3>
                </td>
                <td>
                  <p>{{ spot_duration + " segs. " }}</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-12 col-md-6">
          <table class="table">
            <tbody>
              <tr>
                <td>
                  <h3>{{ $t("descripciones.tipo") }}:</h3>
                </td>
                <td>
                  <p>{{ tipo }}</p>
                </td>
              </tr>
              <tr>
                <td>
                  <h3>{{ $t("descripciones.orientacion") }}:</h3>
                </td>
                <td>
                  <p>{{ $t("facing." + facing) }}</p>
                </td>
              </tr>
              <tr>
                <td>
                  <h3>{{ $t("descripciones.frecuencia") }}:</h3>
                </td>
                <td>
                  <p>{{ frequency ? frequency + " spots/día" : "" }}</p>
                </td>
              </tr>
              <tr>
                <td>
                  <h3>{{ $t("descripciones.operacion") }}:</h3>
                </td>
                <td>
                  <p>
                    {{ operation_hours ? operation_hours + " horas/día" : "" }}
                  </p>
                </td>
              </tr>
              <!--<tr>
                <td>
                  <h3>{{ $t("descripciones.iluminada") }}:</h3>
                </td>
                <td>
                  <p>{{ iluminated }}</p>
                </td>
              </tr>-->
            </tbody>
          </table>
        </div>
        <div class="col-12 col-md-6">
          <div class="bottom-details">
            <h3>{{ $t("descripciones.detalles") }}:</h3>
            <p v-html="($i18n.locale == 'en' ? details_en : details) ||
              $t('descripciones.nodetalles')
              "></p>
          </div>
        </div>
        <div v-if="($i18n.locale == 'en' && contracting_notes) || contracting_notes" class="col-12 col-md-6">
          <div class="bottom-details">
            <h3>{{ $t("descripciones.notas") }}:</h3>
            <p v-html="($i18n.locale == 'en'
              ? contracting_notes_en
              : contracting_notes) || $t('descripciones.nonotas')
              "></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//mixins
import VallasMixin from "../../mixins/vallas.js";
// eslint-disable-next-line
let lity_ = null;
import { VueLoading } from "vue-loading-template";
import VueLoadImage from "vue-load-image";

export default {
  props: ["lista_espacios", "cardinal_directions", "ciudades", "types"],
  mixins: [VallasMixin],
  mounted() {
    // eslint-disable-next-line
    $(document).ready(function () {
      // eslint-disable-next-line
      $(document).on("lity:open", function () {
        document.getElementById("app").style.position = "fixed";
      });
      // eslint-disable-next-line
      $(document).on("lity:close", function () {
        document.getElementById("app").style.position = "relative";
      });
    });
  },
  data() {
    return {
      titulo: "",
      subtitle: "",
      image: "",
      id: "",
      location_id: "",
      screen_size: "",
      screens_circuit: "",
      pixels: "",
      spot_duration: "",
      type_id: "",
      facing_id: "",
      frequency: "",
      operation_hours: "",
      iluminated: false,
      part_circuit: false,
      details: "",
      details_en: "",
      contracting_notes: "",
      contracting_notes_en: "",
      data_server: null,
      inTheList: false,
      loadign: false,
      group_type: ""
    };
  },
  components: {
    VueLoading,
    "vue-load-image": VueLoadImage,
  },
  computed: {
    facing: function () {
      return this.returnDir(this.facing_id).name;
    },
    ciudad: function () {
      return this.returnCiudad(this.location_id);
    },
    tipo: function () {
      return this.returnType(this.type_id).name;
    },
  },
  methods: {
    show(data) {
      this.setInfo(data);
      // eslint-disable-next-line
      lity_ = lity("#billboard-window");
    },
    setInfo(data) {
      this.data_server = data;
      this.titulo = data.address;
      this.subtitle = data.subtitle;
      this.image = Array.isArray(data.images)
        ? data.images[0].image_path
        : data.image.image_path;
      this.id = data.id;
      this.location_id = data.location_id;
      this.screen_size = data.screen_size;
      this.screens_circuit = data.screens_circuit;
      this.pixels = data.pixels;
      this.spot_duration = data.spot_duration;
      this.type_id = data.type_id;
      this.facing_id = data.facing_id;
      this.frequency = data.frequency;
      this.operation_hours = data.operation_hours;
      this.iluminated = data.iluminated;
      this.part_circuit = data.part_circuit && data.part_circuit === 'yes';
      this.details = data.details;
      this.details_en = data.details_en;
      this.contracting_notes = data.contracting_notes;
      this.contracting_notes_en = data.contracting_notes_en;
      this.group_type = data.group_type;
      this.inTheList = this.existInList();
    },
    addList() {
      this.$root.$emit("EventAddToList", this.data_server);
      // eslint-disable-next-line
      lity_.close();
      this.inTheList = true;
    },
    removeList() {
      this.$root.$emit("EventRemoveList", this.data_server);
      this.inTheList = false;
    },
    existInList() {
      let vm = this,
        result = false;
      // eslint-disable-next-line
      _.forEach(this.lista_espacios, (item) => {
        // eslint-disable-next-line
        _.forEach(item.vallas, (element) => {
          if (element.id == vm.id) {
            result = true;
          }
        });
      });
      ``;
      return result;
    },
  },
};
</script>

<i18n src="@/locale/modals/generic.json" />
